// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__ZS5Wz__oBlIk","overlay-content":"style_overlay-content__IVFmc__oBlIk","state-tag":"style_state-tag__+59RJ__oBlIk"};